module.exports = __webpack_public_path__ + "1bab54ab6dcc1304c7ef5e04bd5156cb.svg";